import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { HttpParams, HttpClient } from '@angular/common/http';
import { OneSignalService } from "@app/onesignal.service";
import { Http } from '@angular/http';
@Injectable()
export class AppStateService {
  public stateSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loggedIn = this.stateSource.asObservable();
  constructor(
    public http: Http,
    public httpClient: HttpClient,
    private oneSignalService: OneSignalService,
    ) { }
  setState(value: boolean) {
    this.stateSource.next(value);
  }

  logout(accessToken: string) {
    let params: HttpParams;
    const deviceToken = this.oneSignalService.oneSignalId;
    if (deviceToken) {
      params = new HttpParams()
      .set('access_token', accessToken)
      .append('deviceToken', deviceToken);
    } else {
      params = new HttpParams().set('access_token', accessToken);
    }
    // const headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'multipart/form-data');
    return this.httpClient.post('users/logout', {}, { params: params });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/app-state.service.ts